import { RootState } from '@/store/types'
import {
  VacationApplicationsState, VacationApplication,
} from '@/store/applications/vacations/types'
import axios from 'axios'
import { ActionTree } from 'vuex'
import _ from 'lodash'
import moment from 'moment'

const actions: ActionTree<VacationApplicationsState, RootState> = {
  /**
   * 休暇申請取得
   *
   * @param {string} applicationId 申請ID
   */
  getVacationApplication: (
    { commit, dispatch, getters },
    { applicationId }: { applicationId: string },
  ) => axios.get(`/applications/vacation/${applicationId}`).then(async ({ data }) => {
    await Promise.all([
      dispatch('fetchMasterVacationReasons'),
      ...[
        data.tutorId,
      ].map((tutorId: number) => dispatch('getTutor', { tutorId })),
    ])

    const application: VacationApplication = {
      id: applicationId,
      type: 'vacation',
      comment: data.comment || null,
      date: moment(data.date, 'YYYYMMDD'),
      reason: getters.findVacationReasonByCode(data.reasonCode),
      targetTutor: getters.findTutorById(data.tutorId),
      applicant: {
        id: data.applicantId,
        name: data.applicantName,
      },
      status: data.status,
      approvedComment: _(data.events).maxBy('date')?.comment || null,
    }
    commit('gotVacationApplication', application)
  }),

  /**
   * 休暇申請登録
   * @param context
   * @param {VacationApplication} payload 休暇申請内容
   */
  registerVacationApplication: (
    context,
    {
      targetTutor,
      reason,
      date,
      comment,
    }: VacationApplication,
  ) => axios.post('/applications/vacation', {
    tutorId: targetTutor.id,
    reasonCode: reason.code,
    date: moment(date).format('YYYYMMDD'),
    comment,
  }),
}

export default actions
